import type { SurveyFolder } from './api';

export const UNFILED = 'unfiled';
export function folderPath(folders: SurveyFolder[], id: string): string {
  const names: string[] = [], seen = new Set<string>();
  let folder = folders.find(f => f.id === id);
  while (folder && !seen.has(folder.id)) {
    seen.add(folder.id); names.unshift(folder.name);
    folder = folders.find(f => f.id === folder!.parentId);
  }
  return names.join(' / ');
}
export function folderScope(folders: SurveyFolder[], id: string): Set<string> {
  const ids = new Set([id]);
  let changed = true;
  while (changed) {
    changed = false;
    for (const folder of folders) if (folder.parentId && ids.has(folder.parentId) && !ids.has(folder.id)) { ids.add(folder.id); changed = true; }
  }
  return ids;
}
export function inFolder(folderId: string, membership: string | undefined, scope: Set<string>): boolean {
  return !folderId || (folderId === UNFILED ? !membership : !!membership && scope.has(membership));
}
